import SkipActivityButton from './SkipActivityButton';

export default SkipActivityButton;
